import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'lib-flexible'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'animate.css'
// 将所有接口挂载到vue的原型上
import Api from './api/index'
import store from './store'
Vue.prototype.$Api = Api
Vue.use(Vant)

// 仅在开发环境中引入 vConsole
// if (process.env.NODE_ENV === 'development') {
//   const VConsole = require('vconsole'); // 动态引入
//   new VConsole(); // 创建 vConsole 实例
// // }

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
